module.exports = __webpack_public_path__ + "assets/img/food-menu.548538ff.svg";